module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-1.f594e5e1.jpg";